import { faInfoCircle } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { cn } from "../lib/utils";
import { Badge } from "./badge";
import { Label } from "./label";
import { RadioCardGroup, RadioCardGroupItem } from "./radio-card-group";
import Tooltip from "./tooltip";

export interface RadioCardWithTagsOption {
  value: string;
  label: string;
  description: string;
  tags: string[];
  className?: string;
  badgeClassName?: string;
  labelClassName?: string;
}

export interface RadioCardGroupWithTagsProps {
  options: RadioCardWithTagsOption[];
  defaultValue?: string;
  name?: string;
  className?: string;
  onValueChange?: (value: string) => void;
  labelClassName?: string;
}

export const RadioCardGroupWithTags: React.FC<RadioCardGroupWithTagsProps> = ({
  options,
  defaultValue,
  name = "package-options",
  className,
  onValueChange,
  labelClassName,
}) => {
  return (
    <RadioCardGroup
      defaultValue={defaultValue}
      name={name}
      onValueChange={onValueChange}
      className={className}
    >
      {options.map((option) => (
        <RadioCardGroupItem
          key={option.value}
          value={option.value}
          id={option.value}
          className={cn("h-full items-center bg-white", option.className)}
          aria-label={`${option.label}${option.tags.length ? `, ${option.tags.join(", ")}` : ""}`}
        >
          <div className="flex flex-col items-start">
            <div className="flex flex-row gap-2">
              <Label
                className={cn(
                  "text-md align-center cursor-pointer text-black",
                  labelClassName,
                )}
              >
                {option.label === "Large Lot (over 1/2 acre)" ? (
                  <div className="group relative inline-flex items-center text-nowrap">
                    Large Lot
                    <Tooltip
                      content="(over 1/2 acre)"
                      className="hidden md:block"
                    >
                      <FontAwesomeIcon
                        icon={faInfoCircle}
                        className="bg-brand-tertiary-light text-brand-primary-light mx-2 inline h-4 w-4"
                      />
                    </Tooltip>
                  </div>
                ) : (
                  option.label
                )}
              </Label>
              {option.tags.length > 0 && (
                <div
                  role="list"
                  aria-label="Tags"
                  className={cn("flex flex-wrap gap-2", option.badgeClassName)}
                >
                  {option.tags.map((tag) => (
                    <Badge key={tag} variant="secondary">
                      {tag}
                    </Badge>
                  ))}
                </div>
              )}
            </div>
            {option.label === "Large Lot (over 1/2 acre)" && (
              <div className="block text-sm font-light md:hidden">
                (over 1/2 acre)
              </div>
            )}
            <span className="text-brand-primary-regular text-base">
              {option.description}
            </span>
          </div>
        </RadioCardGroupItem>
      ))}
    </RadioCardGroup>
  );
};
